import React from 'react'
import { Box, LinearProgress, Fade } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  // Subtle overlay that doesn't cover the entire table
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '3px', // Very thin overlay
    zIndex: 1000,
    borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
  },
  // Very subtle progress bars
  progressBar: {
    height: 2,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
  },
  // Different progress bar colors - more subtle
  additionProgress: {
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: '#4caf50',
    },
  },
  updateProgress: {
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: '#2196f3',
    },
  },
  mixedProgress: {
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: '#9e9e9e',
    },
  },
}))

const getUpdateConfig = (updateType) => {
  switch (updateType) {
    case 'addition':
      return {
        progressClass: 'additionProgress',
        showProgress: false, // Don't show anything for additions
      }
    case 'update':
      return {
        progressClass: 'updateProgress',
        showProgress: true,
      }
    case 'deletion':
      return {
        progressClass: 'deletionProgress',
        showProgress: false, // Don't show anything for deletions - just let rows disappear
      }
    case 'mixed':
      return {
        progressClass: 'mixedProgress',
        showProgress: true,
      }
    default:
      return {
        progressClass: 'mixedProgress',
        showProgress: true,
      }
  }
}

const TableLoadingOverlay = React.memo(({ isVisible, updateType = null, onDismiss = null }) => {
  const classes = useStyles()
  const config = getUpdateConfig(updateType)

  const fadeTimeout = 150

  const handleClick = () => {
    if (onDismiss) {
      onDismiss()
    }
  }

  // Don't show anything if not visible or if it's an addition (silent)
  if (!isVisible || !config.showProgress) return null

  // Show minimal progress bar for updates/deletions/syncing
  const progressClass = `${classes.progressBar} ${classes[config.progressClass]}`

  return (
    <Fade in={isVisible} timeout={fadeTimeout}>
      <Box
        className={classes.loadingOverlay}
        onClick={onDismiss ? handleClick : undefined}
        style={{ cursor: onDismiss ? 'pointer' : 'default' }}
      >
        <LinearProgress className={progressClass} variant="indeterminate" />
      </Box>
    </Fade>
  )
})

TableLoadingOverlay.displayName = 'TableLoadingOverlay'

export default TableLoadingOverlay
